import { DeleteCircleOutlineIcon } from './DeleteCircleOutlineIcon';

/**
 * author: TheChilliPL
 * id 854068FB-F9DA-40B4-A427-F2317075CD95
 * name delete-circle-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delete-circle-outline.svg
 * tags
 */
export const TrashCanCircleOutlineIcon = DeleteCircleOutlineIcon;
export default TrashCanCircleOutlineIcon